import { render, staticRenderFns } from "./EditDocketEntry.vue?vue&type=template&id=4dbb20df&"
import script from "./EditDocketEntry.vue?vue&type=script&lang=js&"
export * from "./EditDocketEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports